module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie PasswordInput is a type of html <code>&lt;input type = &#39;password&#39; &gt;</code>.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;PasswordInput /&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/PasswordInput/README.md
// module id = 376
// module chunks = 0